'use strict';

module.exports = {
  template: require('./performance-review-invite-import.html'),
  controller: require('./performance-review-invite-import.controller'),
  controllerAs: 'vm',

  bindings: {
    round: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-invite/performance-review-invite-import/index.js
 ** module id = 255
 ** module chunks = 0
 **/